import { HttpErrorResponse } from '@angular/common/http';
import { ViewChildren } from '@angular/core';
import { ElementRef } from '@angular/core';
import { QueryList } from '@angular/core';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faRefresh, faSignIn, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { SecurityRole } from '../../../shared/literals/shared.literal';
import { AuthenticationService } from '../../services/authentication.serivce';
import { INotificationService } from '../../../shared/services/inotification.service';
import { FeedbackMessageService } from '../../../shared/services/feedback-message.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit, OnDestroy, AfterViewInit {

  resetPasswordForm: FormGroup;
  submitted: boolean = false;
  resetPasswordFormErrorMessage: string;

  showResetPasswordScreen: boolean = true;

  @ViewChildren("icon") public icons: QueryList<FaIconComponent>;
  @ViewChild("backgroundImage") public bgImage: ElementRef;

  icon: IconDefinition = faSignIn;
  token: string;

  get f() { return this.resetPasswordForm.controls; }

  constructor(private formBuilder: FormBuilder,
              private auth: AuthenticationService,
              private router: Router,
              private feedbackService: FeedbackMessageService,
              private activatedRouter: ActivatedRoute,
              private notificationService: INotificationService)
  {

  }

  ngOnInit() {
    var session = this.auth.getSession();

    this.token = this.activatedRouter.snapshot.queryParams['token'];

    //The user is logged in, redirect to homepage
    if (this.auth.isLoggedIn()) {
      var baseUrl = window.location.href.replace(this.router.url, '');
      window.location.replace(baseUrl);
    }

    this.resetPasswordForm = this.formBuilder.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
  }

  ngAfterViewInit() {
    var img = this.bgImage.nativeElement as HTMLImageElement;
    img.onload = () => { this.backgroundImageOnload(); }
    img.onerror = () => { this.bgError(); }
    img.src = "../../../../assets/images/epc4.jpg";
    if (img.complete) {
      this.showResetPasswordScreen = true;
    }

  }

  backgroundImageOnload() {
    this.showResetPasswordScreen = true;
  }

  bgError() {
    console.log("Error loading background image");
  }

  ngOnDestroy(): void {
    // Need to clean up our observable subscription to avoid memory leaks 
    this.auth.onDestroy();
  }

  onSubmit() {

    this.submitted = true;

    // stop here if form is invalid
    if (this.resetPasswordForm.invalid) {
      return;
    }

    this.auth.resetPasswordEmail(this.token, this.resetPasswordForm.get('password')?.value, this.resetPasswordForm.get('confirmPassword')?.value).subscribe({
      next: (data: any) => {
        if (data.wasSuccessful) {
      /*    this.notificationService.show({ title: "Success!", type: "success", description: data.message });*/
          this.feedbackService.give({ text: "Success! " + data.message, status: "success" });

          //redirect to login screen
          setTimeout(() => { this.router.navigate(['/Login']); }, 3000);

        } else {
        /*  this.notificationService.show({ title: "Error!", type: "error", description: data.message });*/
          this.feedbackService.give({ text: "Error! " + data.message, status: "error" });
        }
      },
      error: (e: HttpErrorResponse) => {
        var errorMsg: string = e.error;
        if (typeof e.error === "object") {
          errorMsg = e.statusText
        }

        this.resetPasswordFormErrorMessage = errorMsg;
        this.icon = faSignIn;
        return;
      }
    });
  }

  onReset() {
    this.submitted = false;
    this.resetPasswordForm.reset();
  }

}
